export default __webpack_public_path__ + "static/media/0B.4a5eb6bf.png";